import React from 'react';
import {Box, Chip, Grid} from '@mui/material';
import shadow from '../assets/shadow.png';
import Typography from '@mui/material/Typography';
import { HashLink } from 'react-router-hash-link';

export const PlatformDrivers = ({Logo, text , platform}) => {
	const target = `/portfolio/${platform}#portfolioBrowser`;

	return (
		<React.Fragment>
			{/* Desktop: square card */}
			<Box component={HashLink} smooth to={target}
			     border={3} borderRadius={2} borderColor={'#e0dcdc'} width={'200px'} height={'220px'}
			     sx={{
				     display: {xs: 'none', md: 'block'},
				     textDecoration: 'none',
				     transition: 'transform 0.2s ease, box-shadow 0.2s ease',
				     '&:hover': {transform: 'translateY(-4px)', boxShadow: 4},
			     }} style={{background: '#ffffff'}}>
				<Grid container>
					<Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}} paddingTop={'30px'}>
						<Logo width={'120px'}/>
					</Grid>
					<Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}} paddingTop={'10px'}>
						<img
							src={shadow}
							alt="Shadow"
							style={{height: "10%"}}
						/>
					</Grid>
					<Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}}>
						<Typography variant={'subtitle2'} sx={{display: 'flex', justifyContent: 'center'}}>
							{text}
						</Typography>
					</Grid>
					<Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}} paddingTop={'20px'}>
						<Chip color="primary" label={'CHECK DRIVERS'} component={HashLink} smooth to={target} onClick={()=>{}}/>
					</Grid>
				</Grid>
			</Box>
			{/* Mobile: compact tappable row */}
			<Box component={HashLink} smooth to={target}
			     sx={{
				     display: {xs: 'flex', md: 'none'},
				     alignItems: 'center',
				     gap: 1,
				     width: '100%',
				     maxWidth: '420px',
				     marginLeft: 2,
				     marginRight: 2,
				     paddingLeft: 2,
				     paddingRight: 1.5,
				     paddingTop: 1,
				     paddingBottom: 1,
				     border: 2,
				     borderColor: '#e0dcdc',
				     borderRadius: 2,
				     backgroundColor: '#ffffff',
				     textDecoration: 'none',
			     }}>
				<Box sx={{width: '90px', flexShrink: 0, display: 'flex', alignItems: 'center'}}>
					<Logo width={'90px'}/>
				</Box>
				<Typography variant={'caption'} noWrap sx={{flexGrow: 1, color: 'text.primary'}}>
					{text}
				</Typography>
				<Chip color="primary" size="small" label={'CHECK DRIVERS'} sx={{flexShrink: 0}} clickable/>
			</Box>
		</React.Fragment>
	);
};
